<template>
  <div>
    <h1 class="common__main-title">Mail Tutors</h1>
    <div>
      <TutorMailTemplateSearch class="mb-3"/>
      <TutorSearch
        class="search"
        @search="changeConditions"
        ref="search"
      />
      <div class="pager-box">
        <PagerComponent v-model="pager" @changePage="fetchTutors" class="mb-2" />
      </div>
      <TutorSendMailComponent :tutors="tutors"/>
      <div class="pager-box">
        <PagerComponent v-model="pager" @changePage="fetchTutors" />
      </div>
    </div>
    <Loading :isLoading="isLoading"/>
  </div>
</template>

<script lang="ts">
import _ from 'lodash';
import { Component, Vue } from 'vue-property-decorator'
import { RootState } from '@/store/types';
import { Tutor, TutorConditions } from '@/store/tutors/types';
import PagerComponent from '@/components/parts/Pager.vue';
import TutorSendMailComponent from '@/components/parts/tutor/TutorSendMail.vue';
import TutorSearch, { TutorSearchConditions } from '@/components/parts/tutor/TutorSearch.vue';
import TutorMailTemplateSearch from '@/components/parts/tutor/TutorMailTemplateSearch.vue';
import Loading from '@/components/parts/modal/Loading.vue';
import { Pager } from '@/store/pager.types';

@Component({
  components: {
    TutorSearch,
    TutorMailTemplateSearch,
    PagerComponent,
    TutorSendMailComponent,
    Loading,
  },
})
export default class TutorsComponent extends Vue {
    isLoading: boolean = false

    conditions: TutorSearchConditions|null = null

    private get tutors(): Tutor[] {
      return (this.$store.state as RootState).tutors.tutors
    }

    private get pager(): Pager {
      return (this.$store.state as RootState).tutors.pager
    }

    created() {
      this.fetchTutors(1)
    }

    private changeConditions(searchConditions: TutorSearchConditions) {
      this.conditions = searchConditions
      this.fetchTutors(1)
    }

    private fetchTutors(page: number = 1) {
      if (this.isLoading) {
        return
      }
      this.isLoading = true

      const conditions: TutorConditions = _.pickBy({
        tutorNameOrId: this.conditions?.tutorNameOrId,
        positions: this.conditions?.positions,
        nationality: this.conditions?.nationality,
        isIncludeTerminationOfService: this.conditions?.isIncludeTerminationOfService,
        genderCodes: this.conditions?.genderCodes,
      })

      this.$store.dispatch('fetchTutors', {
        conditions,
        page,
      }).finally(() => {
        this.isLoading = false;
      })
    }
}
</script>
